import { put, takeLatest } from 'redux-saga/effects';
import callRequestSaga from '~/sagas/utils/request-saga';
import SendDeleteRequestConstants from '~/components/containers/SendDeletionRequestContainer/constants';
import CompanyRequestedForDeletionConstants from '~/components/containers/CompanyRequestedForDeletionContainer/constants';
import { closeSendDeletionRequestModal } from '~/components/containers/SendDeletionRequestContainer/actions';
import CompanySettingsAPI from '~/domain/company/api/company-api';
import BaseException from '~/utils/fetch-wrapper/errors/BaseException';
import NetworkException from '~/utils/fetch-wrapper/errors/NetworkException';
import { showError } from '~/components/containers/UnhandledErrorContainer/actions';
import { logoutUser } from '~/ducks/authentication/actions';

export function* sendDeleteRequest({ reason, contactNumber }) {
  const response = yield* callRequestSaga(
    CompanySettingsAPI.createDeletionRequest,
    {
      request: SendDeleteRequestConstants.SEND_DELETION_REQUEST_REQUEST,
      success: SendDeleteRequestConstants.SEND_DELETION_REQUEST_REQUEST_SUCCESS,
      failure: SendDeleteRequestConstants.SEND_DELETION_REQUEST_REQUEST_ERROR,
    },
    reason,
    contactNumber
  );

  if (!(response instanceof BaseException)) {
    yield put(closeSendDeletionRequestModal());
    yield put(logoutUser());
  }
}

export function* removeCompanyDeletionRequest() {
  const response = yield* callRequestSaga(CompanySettingsAPI.removeCompanyDeletionRequest, {
    request: CompanyRequestedForDeletionConstants.REMOVE_COMPANY_DELETION_REQUEST_REQUEST,
    success: CompanyRequestedForDeletionConstants.REMOVE_COMPANY_DELETION_REQUEST_REQUEST_SUCCESS,
    failure: CompanyRequestedForDeletionConstants.REMOVE_COMPANY_DELETION_REQUEST_REQUEST_ERROR,
  });

  if (!(response instanceof NetworkException)) {
    yield getCompanyDeletionRequestStatus();
  }

  if (response instanceof BaseException && response.firstError) {
    yield put(showError(response.firstError, undefined, true));
  }
}

export function* getCompanyDeletionRequestStatus() {
  yield* callRequestSaga(CompanySettingsAPI.getCompanyDeletionRequestStatus, {
    request: CompanyRequestedForDeletionConstants.GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST,
    success:
      CompanyRequestedForDeletionConstants.GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST_SUCCESS,
    failure: CompanyRequestedForDeletionConstants.GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST_ERROR,
  });
}

export function* sendDeleteRequestSaga() {
  yield takeLatest(
    // @ts-ignore
    SendDeleteRequestConstants.SEND_DELETION_REQUEST,
    sendDeleteRequest
  );
}

export function* removeDeletionRequestSaga() {
  yield takeLatest(
    CompanyRequestedForDeletionConstants.REMOVE_COMPANY_DELETION_REQUEST,
    removeCompanyDeletionRequest
  );
}

export function* getCompanyDeletionRequestStatusSaga() {
  yield takeLatest(
    CompanyRequestedForDeletionConstants.GET_COMPANY_DELETION_REQUEST_STATUS,
    getCompanyDeletionRequestStatus
  );
}

export default [
  sendDeleteRequestSaga,
  removeDeletionRequestSaga,
  getCompanyDeletionRequestStatusSaga,
];
